export default __webpack_public_path__ + "static/media/ic_logo_linhlinh.dcee30b4.png";